import $ from "jquery";
import { breakpoints } from "../../variables.json";

if (matchMedia(`(min-width:${breakpoints.medium})`).matches) {
	$(document).on("mouseenter", ".submenu__trigger", function() {
		$(this).click();
	});

	$(document).on("click", ".submenu__item__link", function() {
		var $link = $(this);

		location.href = $link.attr("href");
	});
}
